export const VehicleFeatures = {
  props: [
    'categories',
  ],
  methods: {
    toggleWasOpened(who){
      this.$emit('closeAllExcept', who);
    }
  }
}